import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";

const CommonLayout = ({
  isVisible,
  setIsVisible,
  isDark,
  setIsDark,
  sidebarOpen,
  setSidebarOpen,
}) => {
  // Sync sidebar visibility as data attribute on body for CSS layout
  useEffect(() => {
    document.body.setAttribute("data-sidebar-visible", isVisible ? "true" : "false");
  }, [isVisible]);

  return (
    <>
      {/* Mobile/Tablet Backdrop Overlay */}
      {isVisible && (
        <div
          className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-[98] lg:hidden transition-all duration-200"
          onClick={() => setIsVisible(false)}
        />
      )}
      <Sidebar
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        setSidebarOpen={setSidebarOpen}
        sidebarOpen={sidebarOpen}
      />
      <Navbar
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        isDark={isDark}
        setIsDark={setIsDark}
      />
      <Outlet
        context={{
          isVisible,
          setIsVisible,
          isDark,
          setIsDark,
          sidebarOpen,
          setSidebarOpen,
        }}
      />
    </>
  );
};

export default CommonLayout;
